import { render, staticRenderFns } from "./TeremShotStatistics.vue?vue&type=template&id=0aa59b2e&scoped=true&"
import script from "./TeremShotStatistics.vue?vue&type=script&lang=js&"
export * from "./TeremShotStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TeremShotStatistics.vue?vue&type=style&index=0&id=0aa59b2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa59b2e",
  null
  
)

export default component.exports